export default __webpack_public_path__ + "static/media/sideWhite_diffuse-min.554346eb.jpg";